import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
`;

export const HeroBand = styled.div`
  width: 100%;
  padding: 8rem 1rem;
  background-image: linear-gradient(
    179.93deg,
    #25468e 0.06%,
    #578bbb 51.17%,
    rgba(255, 255, 255, 0.8) 94.09%
  );

  @media (min-width: 1024px) {
    padding: 8rem 4rem;
  }

  @media (min-width: 1536px) {
    padding: 16rem 8rem;
  }
`;

export const HeroTitle = styled.h4`
  font-size: 2.25rem;
  font-weight: 600;
  color: #fff;
  text-align: center;

  @media (min-width: 1024px) {
    text-align: left;
  }

  @media (min-width: 1280px) {
    font-size: 3rem;
  }

  @media (min-width: 1536px) {
    font-size: 3.75rem;
  }
`;

export const HeroCard = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  border-radius: 40px;
  padding: 1rem;
  margin-top: 4rem;
  background-image: linear-gradient(90deg, #25468e 0%, #578bbb 100%);

  @media (min-width: 1024px) {
    align-items: flex-start;
    padding: 0 4rem;
  }

  @media (min-width: 1280px) {
    height: 450px;
  }

  @media (min-width: 1536px) {
    height: 500px;
    margin-top: 5rem;
  }

  > img.logo {
    width: 200px;
    height: auto;
    z-index: 2;

    @media (min-width: 1280px) {
      width: 250px;
    }

    @media (min-width: 1536px) {
      width: 350px;
    }
  }

  > p {
    width: 100%;
    color: #fff;
    font-size: 1.5rem;
    z-index: 2;
    text-align: center;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);

    @media (min-width: 1024px) {
      max-width: 325px;
      text-align: left;
      text-shadow: none;
    }

    @media (min-width: 1280px) {
      max-width: 400px;
      font-size: 1.875rem;
    }

    @media (min-width: 1536px) {
      max-width: 475px;
      font-size: 2.25rem;
    }
  }

  > img.building {
    width: 100%;
    height: auto;
    position: absolute;
    bottom: 0;
    right: 0;
    opacity: 0.5;

    @media (min-width: 1024px) {
      opacity: 1;
    }

    @media (min-width: 1280px) {
      width: 95%;
    }
  }
`;

export const MarketSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  padding: 8rem 0 6rem;

  > h4 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #fff;
    text-align: center;

    @media (min-width: 1280px) {
      font-size: 1.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 2.25rem;
    }
  }
`;

export const MarketGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const ProjectsCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  @media (min-width: 1024px) {
    width: 50%;
  }
`;

export const ProjectsBadge = styled.div`
  background: var(--color-secondary);
  border-radius: 60px;
  padding: 0.5rem 1rem;

  p {
    color: #fff;
    font-size: 1.25rem;
    font-weight: 600;

    @media (min-width: 1280px) {
      font-size: 1.5rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.875rem;
    }
  }
`;

export const ProjectsBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: var(--color-surface);
  border-radius: 60px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 1rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 2rem;
  }
`;

export const ProjectLogo = styled.div`
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #d9d9d966;
  border-radius: 2rem;
  padding: 2rem;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media (min-width: 1024px) {
    width: calc(50% - 12px);
  }

  @media (min-width: 1280px) {
    height: 200px;
  }
`;

export const StatsCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;

  @media (min-width: 1024px) {
    width: 50%;
    padding-top: 60px;
    gap: 3rem;
  }

  @media (min-width: 1280px) {
    padding-top: 68px;
  }
`;

export const StatsBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  background: var(--color-surface);
  border-radius: 60px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 3rem 1rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    padding: 3rem 2rem;
  }

  @media (min-width: 1280px) {
    padding: 3rem 4rem;
  }
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  h4 {
    font-size: 48px;
    font-weight: 700;
    color: var(--color-secondary);
    line-height: 1;

    @media (min-width: 1280px) {
      font-size: 60px;
    }

    @media (min-width: 1536px) {
      font-size: 80px;
    }
  }

  p {
    font-size: 1.125rem;
    font-weight: 500;
    color: var(--color-secondary);

    @media (min-width: 1280px) {
      font-size: 1.25rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.5rem;
    }
  }
`;

export const HighlightRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;

  span {
    width: 12px;
    height: 150px;
    background: var(--color-secondary);
    border-radius: 10px;
    flex-shrink: 0;

    @media (min-width: 1536px) {
      width: 20px;
    }
  }

  p {
    font-size: 1.125rem;
    font-weight: 500;
    color: var(--color-primary);

    @media (min-width: 1024px) {
      max-width: 350px;
    }

    @media (min-width: 1280px) {
      max-width: 450px;
      font-size: 1.25rem;
    }

    @media (min-width: 1536px) {
      max-width: 550px;
      font-size: 1.5rem;
    }
  }
`;

export const QuemSomos = styled.div`
  width: 100%;
  padding: 0 1rem;

  @media (min-width: 1024px) {
    padding: 0 2rem;
  }

  @media (min-width: 1536px) {
    padding: 0 8rem;
  }
`;

export const QuemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h4 {
    font-size: 36px;
    font-weight: 600;
    color: var(--color-primary);
    text-align: center;

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 48px;
    }

    @media (min-width: 1536px) {
      font-size: 60px;
    }
  }

  p {
    width: 100%;
    font-size: 1.125rem;
    font-weight: 500;
    color: var(--color-primary);
    text-align: center;

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 1.25rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.5rem;
    }

    &.wide {
      @media (min-width: 1024px) {
        max-width: 675px;
      }
      @media (min-width: 1280px) {
        max-width: 1000px;
      }
      @media (min-width: 1536px) {
        max-width: 1325px;
      }
    }

    &.narrow {
      @media (min-width: 1024px) {
        max-width: 375px;
      }
      @media (min-width: 1280px) {
        max-width: 500px;
      }
      @media (min-width: 1536px) {
        max-width: 725px;
      }
    }
  }
`;

export const QuemMedia = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 4rem;
    margin-top: -8rem;
  }

  @media (min-width: 1280px) {
    gap: 6rem;
    margin-top: -9rem;
  }

  @media (min-width: 1536px) {
    margin-top: -12rem;
  }
`;

export const LogoTile = styled.div`
  display: grid;
  place-items: center;
  background: #d9d9d9;
  border-radius: 1rem;
  padding: 3rem 1rem;

  @media (min-width: 1024px) {
    padding: 3rem 2rem;
  }

  @media (min-width: 1280px) {
    padding: 4rem 2rem;
  }

  img {
    width: auto;
    height: 36px;

    @media (min-width: 1280px) {
      height: 50px;
    }

    @media (min-width: 1536px) {
      height: 100px;
    }
  }
`;

export const QuemImage = styled.img`
  width: 100%;
  height: auto;

  @media (min-width: 1024px) {
    width: auto;
    height: 500px;
  }

  @media (min-width: 1280px) {
    height: 600px;
  }

  @media (min-width: 1536px) {
    height: 800px;
  }
`;

export const NumbersSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 4rem 1rem;
  background: var(--color-secondary);

  @media (min-width: 1024px) {
    padding: 4rem 2rem;
  }

  @media (min-width: 1536px) {
    padding: 4rem 8rem;
  }

  > h4 {
    font-size: 1.875rem;
    font-weight: 600;
    color: #fff;
    text-align: center;

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 2.25rem;
    }

    @media (min-width: 1536px) {
      font-size: 3rem;
    }
  }
`;

export const NumbersRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
  padding: 0 1rem;

  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const NumberItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #fff;

  svg {
    width: 40px;
    height: auto;

    @media (min-width: 1536px) {
      width: 48px;
    }
  }

  h4 {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    text-align: center;

    @media (min-width: 1280px) {
      font-size: 30px;
    }

    @media (min-width: 1536px) {
      font-size: 40px;
    }
  }

  p {
    font-size: 1rem;
    font-weight: 500;
    color: #fff;
    text-align: center;

    @media (min-width: 1280px) {
      font-size: 1.125rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.25rem;
    }
  }
`;

export const MvvSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  padding: 1rem 1rem 8rem;
  background: var(--color-primary);

  @media (min-width: 1024px) {
    padding: 2rem 2rem 8rem;
  }

  @media (min-width: 1536px) {
    padding: 8rem 8rem 12rem;
  }

  > img {
    width: auto;
    height: 64px;

    @media (min-width: 1280px) {
      height: 80px;
    }

    @media (min-width: 1536px) {
      height: 100px;
    }
  }
`;

export const MvvGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    column-gap: 2rem;
    row-gap: 4rem;
    height: 400px;
  }

  @media (min-width: 1280px) {
    height: 500px;
  }

  @media (min-width: 1536px) {
    width: 75%;
    height: 600px;
  }
`;

export const MvvCard = styled.div<{ $span?: boolean; $image: string }>`
  position: relative;
  overflow: hidden;
  border-radius: 1.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);

  @media (min-width: 1024px) {
    ${({ $span }) => ($span ? "grid-row: span 2;" : "")}
  }

  .bg {
    position: absolute;
    inset: 0;
    transform: scale(1.1);
    background-image: url(${({ $image }) => $image});
    background-size: cover;
    background-position: center;
    filter: blur(2px);
  }

  .overlay {
    position: absolute;
    inset: 0;
    background:
      linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(39, 73, 144, 0.6) 100%
      ),
      rgba(42, 76, 146, 0.2);
  }

  .content {
    position: relative;
    z-index: 2;
    height: 275px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;

    @media (min-width: 1024px) {
      height: 100%;
      padding: 2rem;
      ${({ $span }) => ($span ? "justify-content: flex-end;" : "")}
    }

    @media (min-width: 1280px) {
      padding: 4rem;
    }

    h4 {
      font-size: 24px;
      font-weight: 600;
      color: #fff;
      text-align: center;

      @media (min-width: 1024px) {
        text-align: left;
      }

      @media (min-width: 1280px) {
        font-size: 30px;
      }

      @media (min-width: 1536px) {
        font-size: 40px;
      }
    }

    p,
    li {
      font-size: 0.875rem;
      font-weight: 500;
      color: #fff;
      text-align: center;

      @media (min-width: 1024px) {
        text-align: left;
      }

      @media (min-width: 1280px) {
        font-size: 1.125rem;
        max-width: 375px;
      }

      @media (min-width: 1536px) {
        font-size: 1.25rem;
        max-width: 425px;
      }
    }

    ul {
      list-style: disc;
      list-style-position: inside;
    }
  }
`;
